// components/SWRProvider.tsx
'use client'

import { ReactNode } from 'react'
import { SWRConfig } from 'swr'
import swrContextConfig from '@services/swr/context.config'

export default function SWRProvider({ children }: { children: ReactNode }) {
  return <SWRConfig value={swrContextConfig}>{children}</SWRConfig>
}
